import React from 'react';
import './BankAccountCard.css';

const BankAccountCard = ({ account, onClick }) => {

  // Функция для форматирования названия банка
  const formatBankName = (bank) => {
    if (!bank) return 'Банк не указан';
    return bank;
  };

  // Функция для получения класса иконки в зависимости от валюты
  const getCurrencyIconClass = (currency) => {
    const currencyMap = {
      'RUB': 'count__main--icon-rub',
      'USD': 'count__main--icon-usd',
      'EUR': 'count__main--icon-eur',
      'CNY': 'count__main--icon-cny'
    };
    return currencyMap[currency] || 'count__main--icon-rub'; // По умолчанию рубль
  };

  return (
    <a 
      href="#" 
      data-fls-block="" 
      data-fls-number="" 
      className="count count--hover"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick(account);
      }}
    >
      <div className={`count__main ${getCurrencyIconClass(account.currency)}`}>
        <div className="count__content">
          <h5 className="count__title count__title--title-20">
            {account.number}
          </h5>
          <div className="count__name">
            {account.bank}
          </div>
        </div>
      </div>
    </a>
  );
};

export default BankAccountCard;